import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "../fonts.css";
import { theme } from "../theme";
import type { ThemeProviderProps } from "../types";

/**
 * The one mount point every portal screen wraps itself in. Not a re-export
 * of a single Material UI component — it composes `ThemeProvider`,
 * `CssBaseline` (the focus-ring and reduced-motion rules live in the
 * theme's `MuiCssBaseline` overrides, see `theme.ts`) and x-date-pickers'
 * `LocalizationProvider`, fixed to the dayjs adapter (ADR-20260824-zd2a) —
 * `DatePicker` throws without an ancestor of this provider. `fonts.css` is
 * imported here as a side effect so every mount point loads the
 * self-hosted `@font-face` declarations (ADR-20260917-jh4s) exactly once,
 * alongside the theme they back.
 */
export function ThemeProvider({ children }: Readonly<ThemeProviderProps>) {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>{children}</LocalizationProvider>
    </MuiThemeProvider>
  );
}
